module.exports = __webpack_public_path__ + "static/media/help.1ff4ba42.svg";